export default {
    dataIterator: {
      rowsPerPageText: 'Items per page:',
      rowsPerPageAll: 'All',
      pageText: '{0}-{1} of {2}',
      noResultsText: 'No matching records found',
      nextPage: 'Next page',
      prevPage: 'Previous page'
    },
    dataTable: {
      rowsPerPageText: 'Rows per page:',
      noDataText: 'No data available',
      sortBy: 'Sort by'
    },
    noDataText: 'No data available',
    carousel: {
      prev: 'Previous visual',
      next: 'Next visual'
    },
    calendar: {
      moreEvents: '{0} more'
    },
    datePicker: {
      itemsSelected: '{0} selected',
      nextMonthAriaLabel: 'Next month',
      nextYearAriaLabel: 'Next year',
      prevMonthAriaLabel: 'Previous month',
      prevYearAriaLabel: 'Previous year'
    },
    pagination: {
      ariaLabel: 'Pagination navigation',
      firstPage: 'First page',
      lastPage: 'Last page',
      nextPage: 'Next page',
      prevPage: 'Previous page',
      page: 'Page',
      currentPage: 'Current page'
    },
    rating: {
      ariaLabel: {
        item: 'Rating {0} of {1}'
      }
    },
    loading: 'Loading...',
    breadcrumbs: {
      divider: '/'
    },
    badge: {
      dot: 'Dot',
      icon: 'Icon'
    },
    chip: {
      close: 'Close'
    },
    alert: {
      close: 'Close alert'
    },
    combobox: {
      noDataText: 'No data available'
    },
    select: {
      noDataText: 'No data available',
      itemsSelected: '{0} item(s) selected'
    },
    fileInput: {
      counter: '{0} file(s)',
      counterSize: '{0} file(s) ({1} in total)'
    },
    timePicker: {
      am: 'AM',
      pm: 'PM'
    },
    dataFooter: {
      itemsPerPageText: 'Items per page:',
      itemsPerPageAll: 'All',
      nextPage: 'Next page',
      prevPage: 'Previous page',
      firstPage: 'First page',
      lastPage: 'Last page',
      pageText: '{0}-{1} of {2}'
    },
    treeview: {
      label: '{0} nodes'
    },
    expansionPanel: {
      expand: 'Expand',
      collapse: 'Collapse'
    },
    stepper: {
      next: 'Next',
      prev: 'Previous'
    },
    tabs: {
      next: 'Next',
      prev: 'Previous'
    },
    tooltip: {
      tooltip: 'Tooltip'
    },
    list: {
      noAction: 'No action',
      selectAll: 'Select all'
    },
    menu: {
      close: 'Close menu'
    },
    snackbar: {
      close: 'Close'
    },
    itemGroup: {
      noAction: 'No action'
    },
    autocomplete: {
      noDataText: 'No data available',
      loading: 'Loading...'
    },
    colorPicker: {
      clear: 'Clear',
      close: 'Close'
    },
    dateRange: {
      divider: 'to'
    },
    input: {
      clear: 'Clear {0}',
      prependAction: 'Prepend action {0}',
      appendAction: 'Append action {0}'
    },
    slider: {
      thumb: {
        label: 'Slider {0}'
      }
    },
    switch: {
      input: {
        label: 'Switch {0}'
      }
    },
    textarea: {
      clear: 'Clear {0}'
    },
    table: {
      ariaLabel: {
        sortDesc: 'Sorted descending.',
        sortAsc: 'Sorted ascending.',
        sortNone: 'Not sorted.',
        activateNone: 'Activate to remove sorting.',
        activateDesc: 'Activate to sort descending.',
        activateAsc: 'Activate to sort ascending.'
      },
      sortBy: 'Sort by'
    },
    footer: {
      itemsPerPageText: 'Items per page:',
      itemsPerPageAll: 'All',
      nextPage: 'Next page',
      prevPage: 'Previous page',
      firstPage: 'First page',
      lastPage: 'Last page',
      pageText: '{0}-{1} of {2}'
    },
    // Additional common keys
    close: 'Close',
    open: 'Open',
    search: 'Search',
    filter: 'Filter',
    apply: 'Apply',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    required: 'Required',
    optional: 'Optional',
    error: 'Error',
    warning: 'Warning',
    success: 'Success',
    info: 'Information',
    confirm: 'Confirm',
    continue: 'Continue',
    back: 'Back',
    submit: 'Submit',
    reset: 'Reset',
    upload: 'Upload',
    download: 'Download',
    preview: 'Preview',
    print: 'Print',
    send: 'Send',
    receive: 'Receive',
    accept: 'Accept',
    reject: 'Reject',
    enable: 'Enable',
    disable: 'Disable',
    active: 'Active',
    inactive: 'Inactive',
    on: 'On',
    off: 'Off',
    yes: 'Yes',
    no: 'No',
    ok: 'OK'
  }